import "./styles/contact.css";
import React from "react";
import { useNavigate } from "react-router-dom";

function Contact() {

const [form, setForm] = React.useState({
  name: "",
  email: "",
  company: "",
  inquiryType: "",
  subject: "",
  website: "",
  timeline: "",
  budget: "",
  message: ""
});

const [loading, setLoading] = React.useState(false);
const [step, setStep] = React.useState(1);
const navigate = useNavigate();

const handleChange = (e) => {
  setForm({
    ...form,
    [e.target.name]: e.target.value
  });
};

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const res = await fetch("/submit_form", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(form)
    });

    if (!res.ok) {
      const errData = await res.json();
      throw new Error(errData.message || "Submission failed");
    }

    navigate("/thank-you");

    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <section className="contact">
      <span className="contact-label">Contact</span>

      <h2 className="contact-headline">
        Get in <span>Touch</span>
      </h2>
    </section>


    <section className="contact-section">
      <div className="contact-container">
        
        {/* Intro text spanning full width */}
        <div className="quote-wrapper">
          <blockquote className="quote-card-modern">
            <span className="quote-mark">“</span>

            <p className="quote-text">
              Potential clients, recruiters, and company HR representatives or executives
              may contact me via the channels mentioned below.
            </p>

            <div className="quote-footer">
              <span className="quote-line"></span>
              <span className="quote-author">Joel George</span>
            </div>
          </blockquote>
        </div>

        <div className="contact-grid">
          
          {/* LEFT INFO */}
          <div className="contact-info">
            <p className="contact-desc">
              I'm always open to discuss exciting projects and new opportunities.
              Let's collaborate!
            </p>

            <div className="info-item">
              <span>📧</span>
              <a href="mailto:contact@joelgeorge.dev.com" className="email-link"><p>contact@joelgeorge.dev</p></a>
            </div>

            <div className="info-item">
              <span>📞</span>
              <a href="tel:+918088208121" className="phone-link"><p>+918088208121</p></a>
            </div>

            <div className="info-item">
              <span>📍</span>
              <p>Bengaluru, Karnataka</p>
            </div>
          </div>

          {/* RIGHT FORM */}         
          <form className="contact-form" onSubmit={handleSubmit}>

            {step === 1 && ( 
              <div className="form-step active"> 
                <input type="text" 
                  name="name" 
                  placeholder="Your Name" 
                  value={form.name} 
                  onChange={handleChange} required 
                /> 

                <input type="email" 
                name="email" 
                placeholder="Your Email" 
                value={form.email} 
                onChange={handleChange} required 
                /> 
                
                <input type="text" 
                name="company" 
                placeholder="Company / Organization" 
                value={form.company} 
                onChange={handleChange} 
                /> 
                
                <select name="inquiryType" 
                value={form.inquiryType} 
                onChange={handleChange} 
                required 
                > 

                  <option value="">
                    Select Inquiry Type
                  </option> 
                  
                  <option value="client-project">
                    Client Project
                  </option> 
                  
                  <option value="recruitment">
                    Recruitment Opportunity
                  </option> 
                  
                  <option value="consulting">
                    Consulting
                  </option> 
                  
                  <option value="collaboration">
                    Collaboration
                  </option> 
                
                  <option value="partnership">
                    Partnership
                  </option> 
                  
                </select>

                <button type="button" 
                  className="next-btn" 
                  onClick={() => setStep(2)} 
                > 
                  Continue → 
                </button> 
              </div> 
            )} 
          
            {step === 2 && ( 
              <div className="form-step active"> 
                <input type="text" name="subject" 
                placeholder="Project / Role / Opportunity" 
                value={form.subject} 
                onChange={handleChange} 
                /> 
                
                <input type="url" 
                name="website" 
                placeholder="Website / LinkedIn" 
                value={form.website} 
                onChange={handleChange} 
                /> 
                
                <input type="text" 
                name="timeline" 
                placeholder="Expected Timeline" 
                value={form.timeline} 
                onChange={handleChange} 
                /> 
                
                <select 
                name="budget" 
                value={form.budget} 
                onChange={handleChange} 
                > 
                  <option value="">
                    Budget Range
                  </option> 
                  
                  <option value="<1000">
                    Under $1,000
                  </option> 
                  
                  <option value="1000-5000">
                    $1k - $5k
                  </option> 
                  
                  <option value="5000-10000">
                    $5k - $10k
                  </option> 
                  
                  <option value="10000+">
                    $10k+
                  </option> 
                  
                </select> 

                <textarea name="message" 
                  placeholder="Tell me about your project, role, or collaboration..." 
                  value={form.message} 
                  onChange={handleChange} required 
                /> 
                    
                <div className="form-actions"> 
                  <button type="button" 
                  className="back-btn" 
                  onClick={() => setStep(1)} 
                  > 
                    ← Back 
                  </button>

                  <button type="submit" 
                  className="submit-btn" 
                  disabled={loading}
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </button>
                </div>
              </div>
            )}   
          </form>
        </div>
      </div>
    </section>
    </>
  );
}

export default Contact;